module.exports = __webpack_public_path__ + "img/googlePlayBg.665c62f9.png";